import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { supabase } from './supabase';
import { MIN_PASSWORD_LENGTH, passwordProblem } from './password-reset';

export function PasswordSetup({onComplete}: {onComplete: () => void}) {
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [reveal, setReveal] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    const problem = passwordProblem(password, confirmation);
    if (problem) { setError(problem); return; }
    setBusy(true); setError('');
    try {
      const result = await supabase.auth.updateUser({password});
      if (result.error) throw result.error;
      onComplete();
    } catch (e) { setError((e as Error).message || 'Could not save your password. Try again.'); }
    finally { setBusy(false); }
  };
  // One eye button shows or hides both fields, so people can check what they typed.
  const type = reveal ? 'text' : 'password';
  return <main className="pending-shell rnr-state"><div className="pending-card">
    <h1>Welcome to Lead Alchemy</h1><p>Choose a password to finish setting up your account.</p>
    <form className="login-form rnr-form" onSubmit={submit}>
      <label htmlFor="new-password">New password</label>
      <div className="rnr-password"><input id="new-password" type={type} autoComplete="new-password" required minLength={MIN_PASSWORD_LENGTH} value={password} onChange={e => setPassword(e.target.value)} />
        <button type="button" className="rnr-password__toggle" aria-label={reveal ? 'Hide password' : 'Show password'} aria-pressed={reveal} onClick={() => setReveal(!reveal)}>{reveal ? <EyeOff/> : <Eye/>}</button></div>
      <small>Use at least {MIN_PASSWORD_LENGTH} characters.</small>
      <label htmlFor="confirm-password">Confirm password</label>
      <input id="confirm-password" type={type} autoComplete="new-password" required minLength={MIN_PASSWORD_LENGTH} value={confirmation} onChange={e => setConfirmation(e.target.value)} />
      {error && <p className="form-error" role="alert">{error}</p>}
      <button className="button button--primary" disabled={busy} type="submit">{busy ? 'Saving…' : 'Save password and continue'}</button>
      <button className="button button--quiet" disabled={busy} type="button" onClick={() => void supabase.auth.signOut()}>Sign out</button>
    </form>
  </div></main>;
}
